export default "__VITE_ASSET__48be531f__"